import { FC } from "react"
import { useTranslation } from "react-i18next"
import styles from "./ActiveEffectList.module.scss"
import { IActiveEffectListProps } from "./types"
import { ActiveEffectRow } from "./ui/ActiveEffectRow"

export const ActiveEffectList: FC<IActiveEffectListProps> = ({ effects }) => {
  const { t } = useTranslation("hero")

  return (
    <section className={styles.ActiveEffectList}>
      <h3 className={styles.ActiveEffectList_title}>
        {t("activeEffects.title")}
      </h3>
      <ul className={styles.ActiveEffectList_rows}>
        {effects.map((effect) => (
          <ActiveEffectRow key={effect.effectCode} effect={effect} />
        ))}
      </ul>
    </section>
  )
}
